import { getTestAttributes, slug } from '@chillibean/component-library';
import DatePicker from 'react-datepicker';

import { getFieldTitle } from '../../../__util__/field';
import withInputLabel from '../hoc/withInputLabel';

export function DateField(props) {
  const {
    disabled,
    handleChange,
    handleBlur,
    fieldID,
    fieldRequired,
    fieldIdentifier = 'date',
    fieldName,
    showError,
    errorMessage,
    calendarOnClose,
    calendarOnOpen,
    calendarOpen,
    date,
    dateFormat,
    dateRestriction,
  } = props;

  const currentDate = new Date();
  const scrollToPopup = () => {
    document.querySelector('.react-datepicker-popper')?.scrollIntoView({
      behavior: 'smooth',
    });
  };
  const handleCalendarClose = () => calendarOnClose && calendarOnClose();
  const handleCalendarOpen = () => {
    scrollToPopup();

    return calendarOnOpen && calendarOnOpen();
  };
  const handleOnBlur = (event) => handleBlur && handleBlur(event, 'date');
  const handleOnChange = (date) => handleChange && handleChange(date, 'date');

  const setDateRestriction = (restrictionToMatch) => {
    if (dateRestriction === restrictionToMatch) {
      return currentDate;
    }
  };

  const getInputClassName = () => {
    const classes = ['form__control form__control--datepicker'];

    if (showError) {
      classes.push('form__control--validation-error');
    }

    return classes.join(' ');
  };

  const getLabelClassName = () => {
    const classes = [];

    if (calendarOpen || date !== null) {
      classes.push('form__control--floating-label');
    }

    return classes.join(' ');
  };

  return (
    <div className="form__field" {...getTestAttributes(`${slug(fieldIdentifier)}-form-field`)}>
      <DatePicker
        id={fieldID}
        style={!fieldName ? { paddingTop: '15px' } : null}
        className={getInputClassName()}
        placeholder=" "
        dateFormat={dateFormat}
        onCalendarClose={handleCalendarClose}
        onCalendarOpen={handleCalendarOpen}
        onChange={(event) => handleOnChange(event)}
        onBlur={(event) => handleOnBlur(event)}
        selected={date}
        disabled={disabled}
        maxDate={setDateRestriction('not_future_date')}
        minDate={setDateRestriction('not_past_date')}
      />
      <label className={getLabelClassName()} htmlFor={fieldID}>
        {getFieldTitle(fieldRequired, fieldName)}
      </label>
      {showError && (
        <div className="form__validation-error" data-test-id={`${slug(fieldIdentifier)}-form-field-error-message`}>
          {errorMessage}
        </div>
      )}{' '}
    </div>
  );
}

export default withInputLabel(DateField);
